/*
 * @Author: wulan
 * @Date: 2021-09-Tu 04:09:47
 * @Last Modified by: wulan
 * @decs:支付入参
 */

import { requestCommonParams } from '@/lib/request/requestCommonParams'
import { getTicket } from '@/utils/user'
import config from '@/config/index'
import { COMMON_INFO } from '@/const/base'
import store from '@/store/index'
import { get } from 'lodash-es'
import { getLocalStorage } from '@/utils/localStorage'
const isH5 = document.body.clientWidth <= 768

export async function payOptions(type) {
  const { lang, lat, lng, cityId } = requestCommonParams()
  const country = get(store, 'state.common.country', '')
  return {
    componentType: type, // managecard 卡管理页  paymentfood 支付页 paymentmethodsfood 支付方式选择页
    city_id: cityId,
    countryCode: country,
    location_country: country,
    country,
    lang, // todo钱包内无es-419翻译，先用es-MX兜底
    latitude: lat,
    longitude: lng,
    origin_id: '', // 品牌标识
    location_cityid: cityId,
    resourceId: 35, // 固定35
    biz_line: 0, // 外卖 固定5
    terminal_id: isH5 ? COMMON_INFO.TERMINAL_ID_H5 : COMMON_INFO.TERMINAL_ID_PC,
    token: getTicket(),
    uid: getLocalStorage('uid') || '',
    businessSource: isH5 ? 'food_h5' : 'food_pc',
    theme: 'theme-global',
    PAYMENT_BASE_URL: config.payApiBase, // 支付绑卡域名
    CASHIER_BASE_URL: config.cashierApiBase, // 收银域名
    // wsgenv: await wsgEnv.getWsgEnv(),
  }
}
